import * as React from "react";
import {
    Button,
    CollectionPreferences, CollectionPreferencesProps,
    Header, Pagination, SpaceBetween, Table, TableProps, TextFilter
} from "@amzn/awsui-components-react-v3";
import {CABLING_MANIFEST_TABLE_CONSTANT, PLANNED_DELIVERIES_PAGE} from "../LmdpConstants";
import {useState} from "react";
import {
    CABLING_RAW_TABLE_CONTENT_SELECTOR_OPTIONS,
    CABLING_RAW_TABLE_VISIBLE_COLUMNS,
    CABLING_TABLE_RAW_COLUMN_CONFIG,
} from "./CablingManifestTableConfig";
import {Delivery} from "../common/GetDeliveriesDetailsGQLResponse";
import {useCollection} from "@amzn/awsui-collection-hooks";
import {TableEmptyState, TableNoMatchState} from "../common-component/table-common-component";
import { CSVLink } from "react-csv";
import {getColumnHeader, getCSVData} from "../helper/TableHelper";
import { SortingState } from "@amzn/awsui-collection-hooks/dist/cjs/interfaces";

interface CablingForecastRawDataProps {
    items: Delivery[],
    isLoading: boolean
}

export default function CablingManifestRawDataTable(props: CablingForecastRawDataProps) {

    const threeWeekCablingForecastColumnDefinition :TableProps.ColumnDefinition<Delivery>[] = CABLING_TABLE_RAW_COLUMN_CONFIG.map(columnConfig => {
        return {
            id:columnConfig.label,
            header: getColumnHeader(columnConfig.header, columnConfig.hoursToUpdate),
            cell:columnConfig.cell,
            width: columnConfig.minWidth,
            sortingComparator:columnConfig.sortingComparator
        }
    });
    const defaultPreferences: CollectionPreferencesProps.Preferences<any> = { pageSize: 100, visibleContent: CABLING_RAW_TABLE_VISIBLE_COLUMNS };
    const [preferences, setPreferences] = useState(defaultPreferences);
    const defaultSortingState: SortingState<Delivery> = {
        sortingColumn: threeWeekCablingForecastColumnDefinition.find(column => column.id === 'AZ') || threeWeekCablingForecastColumnDefinition[0], // default sorting column
        isDescending: false, 
      };

    const {items,actions, collectionProps, filterProps, paginationProps} = useCollection(
        props.items,
        {
            filtering: {
                empty: <TableEmptyState  resourceName={"Cabling Manifest"}/>,
                noMatch: <TableNoMatchState onClearFilter={() => actions.setFiltering('')} />,
            },
            pagination: { pageSize: preferences.pageSize },
            sorting: {
                defaultState: defaultSortingState
              }
        }
    );
    
    const csvData = getCSVData(props.items, CABLING_TABLE_RAW_COLUMN_CONFIG);

    return (
        <Table
            {...collectionProps}
            visibleColumns={preferences.visibleContent}
            loading={props.isLoading}
            columnDefinitions={threeWeekCablingForecastColumnDefinition}
            items={items}
            loadingText={PLANNED_DELIVERIES_PAGE.RESULT.TABLE.LOADING_TEXT}
            resizableColumns
            header={
                <Header
                actions={            
                    <SpaceBetween              
                    direction="horizontal"              
                    size="xs" > 
                    <CSVLink data={csvData} filename={'cabling-manifest.csv'}>
                    <Button iconName="download">                
                   Download            
                   </Button>   
                   </CSVLink>         
                   </SpaceBetween>          }
                >{CABLING_MANIFEST_TABLE_CONSTANT.CABLING_MANIFEST_TABLE_CONSTANT.RESULTS_HEADER}</Header>
            }
            filter = {
                <TextFilter
                    {...filterProps}
                    filteringPlaceholder={'Search with cluster, site, demandId, assetId, az, rackType or cabling status'}
                />
            }
            pagination={<Pagination {...paginationProps} />}
            preferences={
                <CollectionPreferences
                    title="Preferences"
                    confirmLabel="Confirm"
                    cancelLabel="Cancel"
                    disabled={false}
                    preferences={preferences}
                    onConfirm={({ detail }) => {
                        return setPreferences(detail);
                    }}
                    visibleContentPreference={{
                        title: "Select visible columns",
                        options: [
                            {
                                label: "Properties",
                                options: CABLING_RAW_TABLE_CONTENT_SELECTOR_OPTIONS
                            }
                        ]
                    }}
                    pageSizePreference={{
                        title: "Page size",
                        options: [
                          { value: 10, label: "10 deliveries" },
                          { value: 30, label: "30 deliveries" },
                          { value: 50, label: "50 deliveries" },
                          { value: 100, label: "100 deliveries" },
                          { value: 300, label: "300 deliveries" }
                        ]
                      }}

                />
            }
        />
    );
}